import api from './api';

export default {
  list: (params = {}) =>
    api.get('/transactions', {
      params: { functionCode: 'TRANS_VIEW', ...params },
    }).then((r) => r.data),

  listByTiKane: (tiKaneId, params = {}) =>
    api.get(`/transactiontikane/${tiKaneId}`, {
      params: { functionCode: 'TRANS_VIEW', ...params },
    }).then((r) => r.data),

  create: (tiKaneId, data) =>
    api.post(`/transactiontikane/${tiKaneId}`, {
      ...data,
      functionCode: 'TRANS_CREATE',
    }).then((r) => r.data),

  payout: (tiKaneId) =>
    api.post(`/transactiontikane/${tiKaneId}/payout`, {
      functionCode: 'TRANS_PAYOUT',
    }).then((r) => r.data),

  update: (tiKaneId, txId, data) =>
    api.put(`/transactiontikane/${tiKaneId}/${txId}`, {
      ...data,
      functionCode: 'TRANS_UPDATE',
    }).then((r) => r.data),

  remove: (tiKaneId, txId) =>
    api.delete(`/transactiontikane/${tiKaneId}/${txId}`, {
      data: { functionCode: 'TRANS_DELETE' },
    }).then((r) => r.data),
};
